import { __rest, __assign } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import cn from 'classnames';
import { Space } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';
import 'react';
import { AnalyticsProvider } from '../../analytics/context.js';
import { Calculator } from './components/Calculator/Calculator.js';
import { Memo } from './components/Memo/Memo.js';
import { CalculatorProvider } from './context.js';

var SelectionCalculator = function (props) {
    var className = props.className, isLoggedIn = props.isLoggedIn, isLoggedInEsia = props.isLoggedInEsia, other = __rest(props, ["className", "isLoggedIn", "isLoggedInEsia"]);
    var isMobile = useIsMobile();
    return (jsx(AnalyticsProvider, { enableAnalytics: other.enableAnalytics, eventLabelPage: other.eventLabelPage, children: jsx(CalculatorProvider, __assign({}, other, { children: jsxs(Space, { direction: "vertical", size: isMobile ? 8 : 12, className: cn(className), children: [!(isLoggedIn || isLoggedInEsia) && jsx(Memo, {}), jsx(Calculator, { head: other.head, isLoggedInEsia: isLoggedInEsia })] }) })) }));
};

export { SelectionCalculator };
//# sourceMappingURL=SelectionCalculator.js.map
